export default {
  props: {
    dropdownClass: String,
    onClose: Function,
    onOpen: Function,
  },

  mounted() {
    this.$nextTick(() => {
      const current = this.$refs?.dropdownRef
      const onClose = this.onClose
      const onOpen = this.onOpen

      if (onClose) {
        current?.addEventListener('close', onClose)
      }

      if (onOpen) {
        current?.addEventListener('open', onOpen)
      }
    })
  },

  beforeDestroy() {
    const current = this.$refs?.dropdownRef
    const onClose = this.onClose
    const onOpen = this.onOpen

    if (onClose) {
      current?.removeEventListener('close', onClose)
    }

    if (onOpen) {
      current?.removeEventListener('open', onOpen)
    }
  },
}
